module.exports = __webpack_public_path__ + "static/media/C15.8de59ce.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C15.mp4
// module id = qgas
// module chunks = 8